import { render, staticRenderFns } from "./wb-context-menu.vue?vue&type=template&id=96daa8fa&scoped=true"
import script from "./wb-context-menu.vue?vue&type=script&lang=js"
export * from "./wb-context-menu.vue?vue&type=script&lang=js"
import style0 from "./wb-context-menu.vue?vue&type=style&index=0&id=96daa8fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96daa8fa",
  null
  
)

export default component.exports